var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('todo-list',_vm._l((_vm.activeList),function(todo){return _c('todo-list-item',{key:todo.id,attrs:{"slot":"todo-list-item","todo":todo},slot:"todo-list-item"})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }